export class BrandingImages {
  logo: string = '';
  logoMobile: string = '';
  favIcon: string = '';

  constructor() {
    this.logo = '';
    this.logoMobile = '';
    this.favIcon = '';
  }
}
